import { cn } from '@/lib/utils';
import { useTranslation } from 'react-i18next';

const STATUS_CONFIG: Record<string, { dotColor: string; classes: string }> = {
  OPEN: {
    dotColor: 'bg-blue-500',
    classes: 'bg-blue-50 text-blue-700 border-blue-200',
  },
  IN_PROGRESS: {
    dotColor: 'bg-amber-500',
    classes: 'bg-amber-50 text-amber-700 border-amber-200',
  },
  ON_HOLD: {
    dotColor: 'bg-violet-500',
    classes: 'bg-violet-50 text-violet-700 border-violet-200',
  },
  VALIDATED: {
    dotColor: 'bg-emerald-500',
    classes: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  },
  COMPLETED: {
    dotColor: 'bg-emerald-500',
    classes: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  },
  RESOLVED: {
    dotColor: 'bg-emerald-500',
    classes: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  },
  CLOSED: {
    dotColor: 'bg-slate-400',
    classes: 'bg-slate-50 text-slate-500 border-slate-200',
  },
  REOPENED: {
    dotColor: 'bg-orange-500',
    classes: 'bg-orange-50 text-orange-700 border-orange-200',
  },
  CANCELLED: {
    dotColor: 'bg-slate-400',
    classes: 'bg-slate-50 text-slate-500 border-slate-200',
  },
};

interface StatusBadgeProps {
  status: string;
  className?: string;
}

export function StatusBadge({ status, className }: StatusBadgeProps) {
  const { t } = useTranslation('common');
  const config = STATUS_CONFIG[status] || {
    dotColor: 'bg-slate-400',
    classes: 'bg-slate-50 text-slate-600 border-slate-200',
  };

  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full border px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider',
        config.classes,
        className
      )}
    >
      <span className={cn('h-1.5 w-1.5 rounded-full', config.dotColor)} />
      {t(`status.${status}`, { defaultValue: status })}
    </span>
  );
}
